import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/PageHero";
import { CTA } from "./Home";
import { IMAGES, FAQS } from "../data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageHero
        testid="faq-hero"
        eyebrow="FAQ"
        title="Your questions, answered."
        subtitle="Everything you might be wondering about working with Sora Speech Co. If your question isn't here, we'd love to hear from you."
        image={IMAGES.plant}
      />

      <section className="py-12">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-4">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="rounded-[20px] bg-sora-warm border border-sora-stone/30 px-6 shadow-[0_6px_24px_rgba(63,88,115,0.04)]">
                  <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-lg text-sora-slate hover:text-sora-blue hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sora-charcoal/80 leading-relaxed pb-6 text-base">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <CTA />
    </div>
  );
}
